// extracted by mini-css-extract-plugin
export var container = "VariantPicker-module--container--98287";
export var fieldSet = "VariantPicker-module--fieldSet--42b94";
export var labelContainer = "VariantPicker-module--labelContainer--2b50a";
export var notInScrollbar = "VariantPicker-module--notInScrollbar--81441";
export var question = "VariantPicker-module--question--9eb90";